export const globalStyles = {
  body: {
    margin: 0,
    fontFamily: '"Roboto", sans-serif'
  }
}
